module.exports = __webpack_public_path__ + "static/media/diabetes-thumb.193be60f.png";